import { useState } from "react";

import {
	GoogleFreeBookingLinksConnectionStatus,
	GoogleFreeBookingLinksHotelType,
} from "@/lib/gql/__generated__/graphql";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

import {
	FeatureOverview,
	HotelCategoryGuide,
	IntegrationStatus,
	SettingsManagement,
	SetupRequirements,
} from "./components";
import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

const ACCORDION_ITEM_VALUE = "accordion-item-value";

export const AccordionFeatureDescription = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();

	const status = form.watch("status");
	const createdAt = form.watch("createdAt");
	const updatedAt = form.watch("updatedAt");
	const hotelType = form.watch("hotelType");
	const isHotel = hotelType === GoogleFreeBookingLinksHotelType.Hotel;
	const isConnectable = status === GoogleFreeBookingLinksConnectionStatus.Connectable;

	const isUpdated = createdAt !== updatedAt;

	const [openAccordionItemValue, setOpenAccordionItemValue] = useState<string | undefined>(() => {
		if (isHotel && isUpdated && isConnectable) {
			// カテゴリがホテル且つ、設定の更新履歴があり、連携可能な場合は、閉じる
			return undefined;
		}

		return ACCORDION_ITEM_VALUE;
	});

	const handleOpenChange = (openAccordionItemValue: string) => {
		setOpenAccordionItemValue(openAccordionItemValue);
	};

	return (
		<Accordion type="single" collapsible defaultValue={openAccordionItemValue} onValueChange={handleOpenChange}>
			<AccordionItem value={ACCORDION_ITEM_VALUE}>
				<AccordionTrigger>Google 無料予約リンク・設定について</AccordionTrigger>

				<AccordionContent className="p-2">
					<div className="space-y-6">
						<FeatureOverview />
						<HotelCategoryGuide />
						<IntegrationStatus />
						<hr className="my-4" />
						<SetupRequirements />
						<hr className="my-4" />
						<SettingsManagement />
					</div>
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
};
